<template>
    <div>
        <form autocomplete="off" class="loading-viewport">
            <CommonSpinner v-if="isLoading" :box="true" />
            <div class="row g-3 g-lg-4">
                <div class="col-lg-6">
                    <label class="form-label">Qualification <span class="text-danger">*</span></label>
                    <select v-model="form.qualification_id" class="form-select"
                        :class="{ 'is-invalid': v$.form.qualification_id.$error }">
                        <option disabled value="" >--select qualification--</option>
                        <option v-for="(qlOption, uIndex) in qualificationOptions" :key="uIndex" 
                        :value="qlOption.id">{{qlOption.title}} {{ qlOption.description ? `- ${qlOption.description}` : '' }}</option>
                    </select>
                    <div v-for="(item, index) in v$.form.qualification_id.$errors"
                        :key="index" class="invalid-feedback">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label class="form-label">Status <span class="text-danger">*</span></label>
                    <select v-model="form.status"  class="form-select"
                        :class="{ 'is-invalid': v$.form.status.$error }">
                        <option disabled value="" >--select status--</option>
                        <option v-for="(option, stIndex) in statusOptions" :key="stIndex" 
                        :value="option.value">{{option.label}}</option>
                    </select>
                    <div v-for="(item, index) in v$.form.status.$errors"
                        :key="index" class="invalid-feedback">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label> Institution type </label>
                    <select @change="institutionTypeChange()" v-model="form.institution_category_id"
                        class="form-select" :class="{ 'is-invalid': v$.form.institution_category_id.$error }">
                        <option disabled value="">--select--</option>
                        <option v-for="(option, uIndex) in institutionTypes" :key="uIndex"
                            :value="option.id">{{ option.title }}</option>
                    </select>
                    <div v-for="(item, index) in v$.form.institution_category_id.$errors" :key="index"
                        class="invalid-feedback">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label> Institution</label>
                    <multiselect mode="single" searchable valueProp="id" trackBy="title" label="title"
                        noOptionsText="The list is empty, type institution name below"
                        :options="institutionOptions" v-model="form.institution_id"
                        placeholder="--select institution --" @select="form.institution_name = ''">
                        <template v-slot:option="{ option }">
                            <div class="">
                                <span>{{ option.title }}</span>
                            </div>
                        </template>
                    </multiselect>
                </div>
                <div class="col-12">
                    <label class="form-label">Enter institution name if not found in ther list</label>
                    <input  type="text" class="form-control"
                        @change="form.institution_id = ''"
                        v-model="form.institution_name"  :disabled="!!form.institution_id"
                        :class="{ 'is-invalid': v$.form.institution_name.$error }"
                        placeholder="Institution name" />
                    <div v-for="(item, index) in v$.form.institution_name.$errors" :key="index"
                        class="invalid-feedback">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div v-if="isTertiaryInstitution" class="col-lg-6">
                    <label> Course category </label>
                    <select @change="courseTypeChange()" v-model="form.course_category_id"
                        class="form-select" :class="{ 'is-invalid': v$.form.course_category_id.$error }">
                        <option disabled value="">--select--</option>
                        <option v-for="(option, uIndex) in courseTypes" :key="uIndex"
                            :value="option.id">{{ option.title }}</option>
                    </select>
                    <div v-for="(item, index) in v$.form.course_category_id.$errors" :key="index"
                        class="invalid-feedback">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div v-if="isTertiaryInstitution" class="col-lg-6">
                    <label> Course of Study</label>
                    <multiselect mode="single" searchable valueProp="id" trackBy="title" label="title"
                        @select="form.course_name = ''"
                        :options="courseOptions" v-model="form.course_id" placeholder="--select course --">
                        <template v-slot:option="{ option }">
                            <div class="">
                                <span class="mb-0">{{ option.title }}</span>
                            </div>
                        </template>
                    </multiselect>
                </div>
                <div v-if="isTertiaryInstitution" class="col-12">
                    <div class="bd-callout mt-0 mb-2 bd-callout-info">
                        <p class="mb-0"><strong>Can’t find your course of study listed above?</strong> You can submit a request to have it added, it usually takes less than 24 hours. Once added, you can check back to continue.
                        <button @click="popupCourseRequest = true" class="btn btn-link fw-bold p-0" type="button">Create Course Request</button></p>
                    </div>
                </div>
                <div v-if="form.course_id" class="col-lg-6">
                    <label>
                        Cumulative Grade Point Average CGPA
                    </label>
                    <input type="text" v-model="form.cgpa"
                        name="cgpa" class="form-control"
                        placeholder="Enter CGPA" />
                </div>
                <div v-if="form.course_id" class="col-lg-6">
                    <label for="grading_scale" class="form-label">Grading Scale (Highest CGPA scale)</label>
                    <select v-model="form.grading_scale" name="grading_scale" 
                        id="grading_scale" class="form-select">
                        <option disabled value="" >--select grading scale--</option>
                        <option v-for="(gsOption, uIndex) in gradingScaleOptions" :key="uIndex" 
                        :value="gsOption.value">{{gsOption.label}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label class="form-label">
                        Start Date <span class="text-danger">*</span>
                    </label>
                    <div>
                        <CommonDatePicker v-model="form.start_date"
                            :maxDate="new Date()"
                            :error="v$.form.start_date.$error" />
                    </div>
                    <div v-for="(item, index) in v$.form.start_date.$errors" :key="index"
                        class="text-danger small">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">
                        End Date <span class="text-danger">*</span>
                    </label>
                    <div>
                        <CommonDatePicker v-model="form.end_date"
                            :error="v$.form.end_date.$error" />
                    </div>
                    <div v-for="(item, index) in v$.form.end_date.$errors" :key="index"
                        class="text-danger small">
                        <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex mt-3 justify-content-end">
                        <b-button variant="primary" 
                        @click.prevent="editMode? update() : confirm()"
                        type="button">{{editMode? 'Update':'Submit'}}</b-button>
                    </div>
                </div>
            </div>
        </form>

        <b-modal v-model="popupCourseRequest" hide-footer centered header-class="bg-light"
            title="Course Request Form" title-class="fs-6" body-class="bg-light" @hide="popupCourseRequest = false">
            <course-request-form :course-types="courseTypes" v-if="popupCourseRequest" @closeMe="popupCourseRequest = false"/>
        </b-modal>
    </div>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import CourseRequestForm from './CourseRequestForm.vue';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components:{
        CourseRequestForm,
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            isLoading: false,
            popupCourseRequest: false,
            form: {
               institution_category_id: "",
               institution_id: "",
               institution_name: "",

               course_category_id: "",
               course_id: "",
               course_name: "",

               cgpa: "",
               grading_scale: "",

               qualification_id: "",
               status: "",
               start_date: null,
               end_date: null,
               description: "",
            },
            institutionTypes:[],
            institutionOptions:[],

            courseTypes:[],
            courseOptions:[],

            qualificationOptions:[],
            gradingScaleOptions:[
                { value: '4.00', label: '4.00'},
                { value: '5.00', label: '5.00'}
            ],
            statusOptions:[
                { value: "graduated", label: "Graduated" },
                { value: "in_progress", label: "In Progress" },
                { value: "deferred", label: "Deferred" },
                { value: "withdrawn", label: "Withdrawn" },
                { value: "dropped_out", label: "Dropped Out" },
                { value: "suspended", label: "Suspended" }
            ],
            mirrorData: null,
        }
    },
    validations() {
        return {        
            form:{
                institution_category_id: {
                    requiredIf: helpers.withMessage("Institution type is required", required),
                },
                institution_id: {
                    requiredIf: helpers.withMessage("Institution is required if Institution name is not provided",
                        requiredIf(function () {
                            return !this.form.institution_name;
                        })
                    ),
                },
                institution_name: {
                    requiredIf: helpers.withMessage(
                        "Institution name is required when Institution in not selected from the list",
                        requiredIf(function () {
                            return !this.form.institution_id;
                        })
                    ),
                },
                course_category_id: {
                    requiredIf: helpers.withMessage("Course type is required", 
                        requiredIf(function () {
                            return this.checkForTertiary();
                        })
                    ),
                },
                course_id: {
                    requiredIf: helpers.withMessage("Course is required",
                        requiredIf(function () {
                            return this.checkForTertiary();
                        })
                    ),
                },
                qualification_id: {
                    required: helpers.withMessage("Qualification is required", required),
                },
                start_date: {
                    required: helpers.withMessage("Start date is required", required),
                },
                status: {
                    required: helpers.withMessage("status is required", required),
                },
                end_date: {
                    required: helpers.withMessage("End date is required", required),
                },
            },
        }
    },
    computed:{
        isTertiaryInstitution(){
            return this.checkForTertiary()
        }
    },
    methods:{
        async confirm() {
            this.errorMessage = null;
            const result = await this.v$.$validate();
            if (!result) {
                this.alertError(this.v$.$errors[0].$message);
                return;
            }
            const confirmResult = await this.confirmAction({
                title: 'Data Integrity Confirmation',
                html: "<p>Please confirm that all the information provided is accurate and has been thoroughly reviewed.</p> <p class='text-warning'> After submission, you will have 6 hours to make corrections. Beyond that, updates can only be made after one month.</p>",
            });
            if (confirmResult.value) {
                this.create();
            }
        },
        create() {
            const formData = this.getFormData();
            this.$store.dispatch("changeLoaderValue", true)
            this.$http.post('/academic-records/create', formData)
            .then((response) => {
                this.$store.dispatch("changeLoaderValue", false)
                if(response.data.success){
                    this.$emit('addedItem', response.data.data)
                    this.resetForm();
                }
            })
        },
        update(){
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };
                const formData = this.getFormData();
                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post(`/academic-records/${this.editItem.id}/update`, formData)
                    .then((response) => {
                        this.$store.dispatch("changeLoaderValue", false)
                        if(response.data.success){
                            this.$emit('updatedItem', response.data.data)
                            this.resetForm()
                        }
                    })
            
            })
        },
        checkForTertiary(){
            if (!this.form.institution_category_id) {
                return false;
            }
            const institutionType = this.institutionTypes.find(i => i.id === this.form.institution_category_id);
            if (!institutionType) {
                return false;
            }
            return institutionType.title.toLowerCase().includes('tertiary');
        },
        getFormData(){
            if(!this.isTertiaryInstitution){
                this.form.course_category_id = "";
                this.form.course_id = "";
                this.form.grading_scale = "";
                this.form.cgpa = "";
            }
            const formData = new FormData()
            formData.append('data', JSON.stringify(this.form))
            return formData;
        },
        resetForm(){
            this.form = {...this.mirrorData}
            this.v$.$reset()
            this.$emit("closeMe")
        },
        institutionTypeChange(reset = true){
            this.institutionOptions = []
            if(reset) { this.form.institution_id = null }
            this.isLoading = true;
            this.$http.get(this.absoluteApiUrl(`/institutions?category_id=${this.form.institution_category_id}`)).then((response) => {
                this.isLoading = false;
                if(response.data.success){
                    this.institutionOptions = response.data.data
                }
            })
        },
        courseTypeChange(reset = true){
            this.courseOptions = []
            if(reset) { this.form.course_id = null }
            this.isLoading = true;
            this.$http.get(this.absoluteApiUrl(`/courses?category_id=${this.form.course_category_id}`)).then((response) => {
                this.isLoading = false;
                if(response.data.success){
                    this.courseOptions = response.data.data
                }
            })
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(this.absoluteApiUrl(`/categories?type=INSTITUTION`)).then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.institutionTypes = response.data.data
                }
            })
            this.$http.get(this.absoluteApiUrl(`/categories?type=COURSE`)).then((response) => {
                if(response.data.success){
                    this.courseTypes = response.data.data
                }
            })
            this.$http.get(this.absoluteApiUrl(`/qualifications`)).then((response) => {
                if(response.data.success){
                    this.qualificationOptions = response.data.data
                }
            })
        },
    },
    created(){
        this.getOptionData()
        this.mirrorData = JSON.parse(JSON.stringify(this.form))
        if(this.editMode){
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
            this.institutionTypeChange(false)
            this.courseTypeChange(false)
        }
    }
}
</script>